import { MatrixParameterValue } from "../interfaces/MatrixInputCell";

const dropdownCustomValidator = (cell: MatrixParameterValue, callback: (valid: boolean) => void) => {
  const { parameterValue } = cell;
  if (parameterValue.value) {
    const found = parameterValue.parameter.values.find((option: string) => option === parameterValue.value);
    if (found) {
      callback(true);
    } else {
      callback(false);
    }
  } else {
    callback(false);
  }
};

export default dropdownCustomValidator;
